<template>
  <v-dialog v-model="show" :max-width="400" persistent>
    <v-card :loading="loading" v-if="upgrade">
      <v-container>
        <v-row justify="end" class="pr-2">
          <v-btn icon small @click="show=false" v-if="!loading">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-center pt-0">
            <div class="logofont text-shadow">
              <span class="primary--text">Why</span>
              <span class="secondary--text">Buy</span>
            </div>
            <h2 class="font-weight-light">Upgrade to {{upgrade.label}}</h2>
          </v-col>

          <v-col
            cols="12"
            class="text-center pt-0"
            v-if="$store.state.user.billing_cycle==='month'"
          >
            <h1 class="font-weight-light">
              <span class="primary--text font-weight-bold">${{upgrade.cycle['month'].price}}</span>/month
            </h1>
            <span>Up to {{upgrade.limit}} portals</span>
          </v-col>
          <v-col cols="12" class="text-center pt-0" v-if="$store.state.user.billing_cycle==='year'">
            <h1 class="font-weight-light">
              <span class="primary--text font-weight-bold">${{upgrade.cycle['year'].price}}</span>/year
            </h1>

            <span>Up to {{upgrade.limit}} portals</span>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions class="pb-6">
        <v-spacer></v-spacer>
        <v-btn color="blue" dark @click="submitUpgrade" :loading="loading">Upgrade Now</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Upgrade",
  created() {
    this.loading = false;
    this.$eventBus.$on(
      "upgrade-dialog",
      function() {
        this.show = true;
      }.bind(this)
    );
  },
  data() {
    return {
      show: false,
      loading: false
    };
  },
  methods: {
    async submitUpgrade() {
      this.loading = true;
      try {
        await this.$api.patch(`/user/change-membership`, {
          plan: this.upgrade.name
        });
        await this.$store.dispatch("loadUser");
        this.show = false;
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    }
  },
  computed: {
    upgrade() {
      return this.$store.getters["upgrade"];
    }
  }
};
</script>

<style lang="scss" scoped>
.logofont {
  font-family: "Arial Rounded MT Bold", sans-serif;
  font-size: 48px;
  letter-spacing: -2px;
}
</style>